'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSMotion = exports.AnimateChild = undefined;

var _Animate = require('./Animate');

var _Animate2 = _interopRequireDefault(_Animate);

var _AnimateChild = require('./AnimateChild');

var _AnimateChild2 = _interopRequireDefault(_AnimateChild);

var _CSSMotion = require('./CSSMotion');

var _CSSMotion2 = _interopRequireDefault(_CSSMotion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.AnimateChild = _AnimateChild2['default'];
exports.CSSMotion = _CSSMotion2['default'];
exports['default'] = _Animate2['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree/~/rc-animate/lib/index.js
// module id = 2725
// module chunks = 0